const apiVersion = "v2";

const apiRoutes = {
	// dev env
	getPackageVersion: "/api/test/packageVersion",

	// groups
	addRulesToGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/rules`,
	addPluginsToGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/plugins`,
	bulkDeleteGroups: `/api/${apiVersion}/groups/bulk`,
	bulkRemoveIdpGroupsFromGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/idpgroups`,
	bulkRemoveRulesFromGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/rules`,
	bulkRemoveUsersFromGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/users`,
	copyGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/copy`,
	createGroup: `/api/${apiVersion}/groups`,
	deleteGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}`,
	getGroupIdpGroups: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/idpGroups`,
	getGroupById: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}`,
	getGroupByName: `/api/${apiVersion}/groups/group`,
	getGroups: `/api/${apiVersion}/groups`,
	getGroupPlugins: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/plugins`,
	removeIdpGroupFromGroup: (groupId: number | string, idpGroupId: number | string) => `/api/${apiVersion}/groups/${groupId}/idpgroups/${idpGroupId}`,
	removeRuleFromGroup: (groupId: number | string, ruleId: number | string) => `/api/${apiVersion}/groups/${groupId}/rule/${ruleId}`,
	updateGroup: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}`,
	updateGroupIdpGroups: (groupId: number | string) => `/api/${apiVersion}/groups/${groupId}/idpgroups`,
	updateGroupPlugin: (groupId: number | string, pluginId: number | string) => `/api/${apiVersion}/groups/${groupId}/plugin/${pluginId}`,

	//organizations
	getOrganizationWithSamlMetadata: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/saml`,
	getOrganization: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}`,
	getOrganizationIdpGroups: `/api/${apiVersion}/organizations/idpgroups`,
	getExternalGroups: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/externalGroups`,
	getExternalGroupMembers: (orgId: number | string, externalGroupId: string) => `/api/${apiVersion}/organizations/${orgId}/externalGroups/${externalGroupId}/members`,
	patchOrganization: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}`,
	setSamlAppMetadata: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/saml`,
	ssoAndScim: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/ssoAndScim`,
	sync: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/sync`,
	syncByTenantId: `/api/${apiVersion}/organizations/syncByTenantId`,
	validateRoleMappings: `/api/${apiVersion}/organizations/scim/validate`,

	// collections
	createCollection: `/api/${apiVersion}/collections`,
	deleteCollections: `/api/${apiVersion}/collections`,
	getCollections: (platformId?: number | string) =>
		platformId != null && String(platformId).trim() !== ""
			? `/api/${apiVersion}/collections?platformId=${platformId}`
			: `/api/${apiVersion}/collections`,
	getCollectionEntries: (collectionId: number | string) => `/api/${apiVersion}/collections/${collectionId}/entries`,
	createCollectionEntries: (collectionId: number | string) => `/api/${apiVersion}/collections/${collectionId}/entries`,
	updateCollectionEntries: (collectionId: number | string) => `/api/${apiVersion}/collections/${collectionId}/entries`,
	patchCollection: (collectionId: number | string) => `/api/${apiVersion}/collections/${collectionId}`,

	// config
	getAssignmentOperators: `/api/${apiVersion}/config/operators/assignment`,
	getComparativeOperators: `/api/${apiVersion}/config/operators/comparative`,
	getFormulaOperators: `/api/${apiVersion}/config/operators/formula`,
	getFormMetadata: `/api/${apiVersion}/config/form-metadata`,
	getDataTypes: `/api/${apiVersion}/configdatatypes`,

	// permissions
	getPermissions: `/api/${apiVersion}/permissions`,

	// plugins
	addGroupsToPlugin: (pluginId: number | string) => `/api/${apiVersion}/plugins/${pluginId}/groups`,
	bulkRemoveGroupsFromPlugin: (pluginId: number | string) => `/api/${apiVersion}/plugins/${pluginId}/groups`,
	getPlugin: (pluginId: number | string) => `/api/${apiVersion}/plugins/${pluginId}`,
	getPlatforms: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/platforms`,
	getPlatformsAndPlugins: (orgId: number | string) => `/api/${apiVersion}/organizations/${orgId}/platforms-and-plugins`,
	getGroupsForPlugin: (pluginId: number | string) => `/api/${apiVersion}/plugins/${pluginId}/groups`,
	patchPlugin: (pluginId: number | string) => `/api/${apiVersion}/plugins/${pluginId}`,
	removeGroupFromPlugin: (pluginId: number | string, groupId: number | string) => `/api/${apiVersion}/plugins/${pluginId}/groups/${groupId}`,

	// roles
	addIdpGroupsToRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/idpgroups`,
	addUsersToRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/users/add`,
	bulkDeleteRoles: `/api/${apiVersion}/roles/bulk`,
	bulkRemoveIdpGroupsFromRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/idpgroups`,
	bulkRemoveUsersFromRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/users`,
	copyRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/copy`,
	createRole: `/api/${apiVersion}/roles`,
	deleteRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}`,
	getRoles: `/api/${apiVersion}/roles`,
	getRoleById: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}`,
	getRoleIdpGroups: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/idpGroups`,
	removeIdpGroupFromRole: (roleId: number | string, idpGroupId: number | string) => `/api/${apiVersion}/roles/${roleId}/idpgroups/${idpGroupId}`,
	removeUserFromRole: (roleId: number | string, userId: number | string) => `/api/${apiVersion}/roles/${roleId}/users/${userId}/remove`,
	updateRole: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}`,
	updateRoleIdpGroups: (roleId: number | string) => `/api/${apiVersion}/roles/${roleId}/idpGroups`,
	updateRolePermission: (roleId: number | string, permissionId: number | string) => `/api/${apiVersion}/roles/${roleId}/permissions/${permissionId}`,

	// rules
	bulkApplyRuleChanges: `/api/${apiVersion}/rules/bulk`,
	bulkDeleteRules: `/api/${apiVersion}/rules/bulk`,
	bulkPermanentDeleteRules: `/api/${apiVersion}/rules/bulk`,
	bulkRestoreRules: `/api/${apiVersion}/rules/bulk/restore`,
	bulkUpdateRuleStatus: `/api/${apiVersion}/rules/bulk`,
	createRule: `/api/${apiVersion}/rules`,
	copyRule: (ruleId: number | string) => `/api/${apiVersion}/rules/${ruleId}/copy`,
	deleteRule: `/api/${apiVersion}/rules`,
	getRule: (ruleId: number | string) => `/api/${apiVersion}/rules/${ruleId}`,
	getRules: `/api/${apiVersion}/rules`,
	getRuleByName: `/api/${apiVersion}/rules/rule`,
	updateRule: (ruleId: number | string) => `/api/${apiVersion}/rules/${ruleId}`,
	toggleRuleStatus: (ruleId: number | string) => `/api/${apiVersion}/rules/${ruleId}/toggleStatus`,
	restoreRule: (ruleId: number | string) => `/api/${apiVersion}/rules/${ruleId}/restore`,

	//requests
	getRequest: `/api/${apiVersion}/requests`,
	requestUpdate: `/api/${apiVersion}/requests`,

	// screen locations
	getRuleLocationsForWizard: (platformId: number | string) => `/api/${apiVersion}/configScreenLocations?platformId=${platformId}`,
	getRuleLocation: (ruleLocationId: number | string) => `/api/${apiVersion}/configScreenLocations/${ruleLocationId}`,

	// advanced triggers
	getAdvancedTriggers: (orgId: number | string, platformId: number | string) =>
		`/api/${apiVersion}/advancedTriggers/organizations/${orgId}/platforms/${platformId}`,

	// screen fields
	getScreenFields: (ruleLocationId: number | string) => `/api/${apiVersion}/config/screen-locations/${ruleLocationId}/screen-fields`,

	// table groups
	getTableOptions: (platformId: number | string) => `/api/${apiVersion}/config/tables?platformId=${platformId}`,
	getDatabaseTableOptions: (platformId: number | string) => `/api/${apiVersion}/config/database-tables?platformId=${platformId}`,
	getScreenTableFields: (tableId: number | string) => `/api/${apiVersion}/config/screen-tables/${tableId}/fields`,
	getDatabaseTableFields: (tableId: number | string) => `/api/${apiVersion}/config/database-tables/${tableId}/fields`,

	// tags
	createTag: `/api/${apiVersion}/tags`,
	getTags: `/api/${apiVersion}/tags`,
	getStopTags: `/api/${apiVersion}/rulenodes/stop-tags`,
	getPossibleParentTags: `/api/${apiVersion}/tags/getPossibleParentTags`,
	deleteTag: `/api/${apiVersion}/tags`,
	updateTag: `/api/${apiVersion}/tags`,

	// users
	addUsersToGroup: `/api/${apiVersion}/users/addUsersToGroup`,
	bulkDeleteUsers: `/api/${apiVersion}/users/bulk`,
	updateUser: `/api/${apiVersion}/users`,
	createUser: `/api/${apiVersion}/users`,
	deleteUser: (userId: number | string) => `/api/${apiVersion}/users/${userId}`,
	getUser: (isSelf: number, id: number | string, email: string, tenantId: string) => `/api/${apiVersion}/users/user?isSelf=${isSelf}&id=${id}&email=${email}&tenantId=${tenantId}`,
	getUsers: `/api/${apiVersion}/users`,
	setUserActive: (userId: number | string) => `/api/${apiVersion}/users/${userId}/active`,
	removeUserFromGroup: (userId: number | string, groupId: number | string) => `/api/${apiVersion}/users/${userId}/group/${groupId}`,

	// workstations
	getWorkstations: `/api/${apiVersion}/workstations`,
	bulkWorkstationKillSwitchToggle: `/api/${apiVersion}/workstations/bulk/killSwitch`,
	workstationKillSwitch: (uuid: string) => `/api/${apiVersion}/workstations/${uuid}/killSwitch`,
	patchWorkstation: (uuid: string) => `/api/${apiVersion}/workstations/${uuid}`,
};

export default apiRoutes;
